import { ref } from "vue";

export const COLORS_IN_HTML = ref({
  drawer: "#3A9B6B",
});

export function changeColor(color: string) {
  COLORS_IN_HTML.value.drawer = color;
}

export const COLOR = {
  green: "#427739",
  yellow: "#F9DC4B",
  red: "#E04637",
  orange: "#F9A825",
  grey: "#CAC8C8",
  greyfake: "#00A5E8",
  background: "#1E1E2F",
  backgroundLight: "#DADADD",
  card: "#242433",
  purple: "#A323C5",
  blue: "#4850F0",
  error: "#F44336",
  modify: "#2196F3",
  warning: "#FF9800",
  single: "#00CCFF",
  compare1: "#FF0033",
  compare2: "#00CCFF",
  compare3: "#1F28E9",
  compare13: "#B400FE",
  compare14: "#04FA6D",
  bgpredict: "#0047AB",
};
